import { Button, SimpleGrid, Switch } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { COLOR_THEME_OPTIONS } from "@/app/theme";
import { useColorTheme } from "@/app/use-color-theme";
import { useMotion } from "@/app/use-motion";
import { SettingPanel } from "@/features/account/ui/setting-panel";

export function PortalAppearancePanel() {
	const { t } = useTranslation();
	const { theme, setTheme, scheme, setScheme } = useColorTheme();
	const { motion, setMotion, headerFx, setHeaderFx, navFx, setNavFx } =
		useMotion();

	return (
		<>
			<SettingPanel title={t("staff.schemeTitle")} hint={t("staff.schemeHint")}>
				<SimpleGrid cols={2} spacing="xs">
					<Button
						variant={scheme === "light" ? "filled" : "default"}
						onClick={() => setScheme("light")}
					>
						{t("staff.schemeLight")}
					</Button>
					<Button
						variant={scheme === "dark" ? "filled" : "default"}
						onClick={() => setScheme("dark")}
					>
						{t("staff.schemeDark")}
					</Button>
				</SimpleGrid>
			</SettingPanel>
			<SettingPanel title={t("staff.themeTitle")} hint={t("staff.themeHint")}>
				<SimpleGrid cols={2} spacing="xs">
					{COLOR_THEME_OPTIONS.map(({ value, labelKey }) => (
						<Button
							key={value}
							variant={theme === value ? "filled" : "default"}
							onClick={() => setTheme(value)}
						>
							{t(labelKey)}
						</Button>
					))}
				</SimpleGrid>
			</SettingPanel>
			<SettingPanel title={t("staff.motionTitle")} hint={t("staff.motionHint")}>
				<Switch
					checked={motion}
					onChange={(event) => setMotion(event.currentTarget.checked)}
					label={motion ? t("staff.motionOn") : t("staff.motionOff")}
				/>
			</SettingPanel>
			<SettingPanel
				title={t("staff.seasonFxTitle")}
				hint={t("staff.seasonFxHint")}
			>
				<Switch
					checked={headerFx}
					onChange={(event) => setHeaderFx(event.currentTarget.checked)}
					label={t("staff.seasonFxHeader")}
				/>
				<Switch
					checked={navFx}
					onChange={(event) => setNavFx(event.currentTarget.checked)}
					label={t("staff.seasonFxNav")}
				/>
			</SettingPanel>
		</>
	);
}
